<!-- [Input] Text / Number / Email -->
<div *ngIf="is.text || is.number || is.email" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div *ngIf="item.label" [innerHTML]="item.label | safeHtml" class="infinity-label"></div>
    <input *ngIf="is.number && !mask" [id]="displayId" type="number" [disabled]="item.disabled" [placeholder]="placeholder" [attr.maxlength]="item.maxLength || null" (keyup)="updateFromInput(item, 'value', $event.target.value)" (mouseup)="updateFromInput(item, 'value', $event.target.value)" />
    <input *ngIf="!is.number && !mask" [id]="displayId" type="text" [disabled]="item.disabled" [placeholder]="placeholder" [attr.maxlength]="item.maxLength || null" (keyup)="updateFromInput(item, 'value', $event.target.value)" (mouseup)="updateFromInput(item, 'value', $event.target.value)">
    <input *ngIf="mask && mask !== 'separator' && mask !== 'currency'" [id]="displayId" type="text" [disabled]="item.disabled" [placeholder]="placeholder" [attr.maxlength]="item.maxLength || null" [mask]="mask" (keyup)="updateFromInput(item, 'value', $event.target.value)">
    <input *ngIf="mask && mask === 'separator'" [id]="displayId" type="text" [disabled]="item.disabled" [placeholder]="placeholder" [mask]="mask" thousandSeparator="," (keyup)="updateFromInput(item, 'value', $event.target.value)">
    <input *ngIf="mask && mask === 'currency'" [id]="displayId" type="text" [disabled]="item.disabled" [placeholder]="placeholder" prefix="$" mask="separator" thousandSeparator="," (keyup)="updateFromInput(item, 'value', $event.target.value)">
</div>

<!-- [Input] cc -->
<div *ngIf="is.cc" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div *ngIf="item.label" [innerHTML]="item.label | safeHtml" class="infinity-label"></div>
    <iframe 
        id="tokenframe" 
        name="tokenframe" 
        title="Card Connect Token Frame"
        frameborder="0" 
        scrolling="no" 
        allow="clipboard-write; clipboard-read">
    </iframe>
</div>

<!-- [Input] Date -->
<div *ngIf="is.date" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div *ngIf="item.label" [innerHTML]="item.label | safeHtml" class="infinity-label"></div>
    <input [id]="displayId" type="text" [disabled]="item.disabled" [placeholder]="placeholder" (keydown)="maskDate($event, maxSlashes, maxDigits, maxLast)" (keyup)="queueUpdate($event)">
</div>

<!-- [Input] Textarea -->

<div *ngIf="is.textarea" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div *ngIf="item.label" [innerHTML]="item.label | safeHtml" class="infinity-label"></div>
    <textarea [id]="displayId" [disabled]="item.disabled" [placeholder]="placeholder" (keyup)="updateFromInput(item, 'value', $event.target.value)"></textarea>
</div>

<!-- [Input] Attachment -->

<div *ngIf="is.attachment" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div *ngIf="item.label" [innerHTML]="item.label | safeHtml" class="infinity-label"></div>
    <input type="file" [id]="displayId" (change)="updateFromFile($event.target.files)">
</div>

<!-- [Selection] Checkbox -->

<div *ngIf="is.checkbox" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <input [type]="item.type" [id]="displayId" [name]="item.itemId" [attr.aria-labelledby]="item.label ? displayId + '-label' : null" (click)="updateFromInput(item, 'value', !item.value)">
    <div class="fake-checkbox">
        <div class="fake-check"></div>
    </div>
    <span *ngIf="item.label" [id]="displayId + '-label'" [innerHTML]="item.label | safeHtml"></span>
</div>

<!-- [Selection] Radio -->

<div *ngIf="is.radio" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <input [type]="item.type" [id]="displayId" [name]="item.parentItemId" (change)="updateFromInput(parent, 'value', item.itemId)">
    <label class="infinity-selection-label" [attr.for]="displayId">
        <span class="fake-radiobox">
            <span class="fake-radio"></span>
        </span>
        <span *ngIf="item.label" [innerHTML]="item.label | safeHtml"></span>
    </label>
</div>

<!-- [Selection] Dropdown -->

<div *ngIf="is.dropdown" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div *ngIf="item.label" [innerHTML]="item.label | safeHtml" class="infinity-label"></div>
    <div class="fake-dropdown-arrow"></div>
    <select [id]="displayId" (change)="updateFromInput(item, 'value', $event.target.options[$event.target.selectedIndex].value)" [disabled]="item.disabled">
        <option value="">{{placeholder}}</option>
        <ng-template ngFor let-child [ngForOf]="item.items">
            <option *ngIf="child.visible" [value]="child.value || child.label" [disabled]="child.disabled">{{child.label}}</option>
        </ng-template>
    </select>
</div>

<!-- [Group] Form / None -->

<div *ngIf="is.form || is.none" [class]="className" [id]="displayId" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div *ngIf="item.label" [innerHTML]="item.label | safeHtml"></div>
    <infinity-item *ngFor="let child of item.items" [item]="child" [parent]="item" [actions]="actions"></infinity-item>
</div>

<!-- [Group] Checkbox Group -->

<div *ngIf="is.checkboxGroup" [class]="className" [id]="displayId" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div *ngIf="item.label" [innerHTML]="item.label | safeHtml" class="infinity-label"></div>
    <infinity-item *ngFor="let child of item.items" [item]="child" [parent]="item" [actions]="actions"></infinity-item>
</div>

<!-- [Group] Radio Group -->

<div *ngIf="is.radioGroup" [id]="displayId" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div *ngIf="item.label" [innerHTML]="item.label | safeHtml" class="infinity-label"></div>
    <infinity-item *ngFor="let child of item.items" [item]="child" [parent]="item" [actions]="actions"></infinity-item>
</div>

<ng-template [ngIf]="is.radioGroup">
    <ng-template ngFor let-child [ngForOf]="item.items">
        <ng-template [ngIf]="child.items">
            <infinity-item *ngFor="let grandChild of child.items" [item]="grandChild" [parent]="child" [actions]="actions"></infinity-item>
        </ng-template>
    </ng-template>
</ng-template>

<!-- [Group] Aggregate -->

<div *ngIf="is.aggregate" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div *ngIf="item.label" [innerHTML]="item.label | safeHtml" class="pad-6-12 infinity-label"></div>
    <div class="col-md-6">
        <infinity-item *ngFor="let child of item.items" [item]="child" [parent]="item" [actions]="actions"></infinity-item>
    </div>
    <div class="infinity-text col-md-6 aggregate">
        <div *ngIf="item.hint" [innerHTML]="item.hint | safeHtml"></div>
        <input disabled [id]="displayId">
    </div>
</div>

<!-- [Content] Modal -->

<div *ngIf="is.modal" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div class="abs-tl align fill pointer" (click)="updateFromInput(item, 'value', false)" (keydown.enter)="updateFromInput(item, 'value', false)" (keydown.space)="updateFromInput(item, 'value', false); $event.preventDefault()">
        <div class="bg-255 border-2-160 cursor-default pad-24 rel" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <button type="button" class="abs-tr bg-245 border-2-160 close pad-6-12 pointer" (click)="updateFromInput(item, 'value', false)">x</button>
            <div *ngIf="item.value" [innerHTML]="item.value | safeHtml"></div>
        </div>
    </div>
</div>

<!-- [Content] Spinner -->

<div *ngIf="is.spinner" [class]="className" [ngClass]="{ hide: !item.value, valid: item.valid, required: item.required }">
    <div class="hw-40px rel">
        <div class="abs-tl bg-40 circle fill o-5"></div>
        <div class="abs-tl bg-40 circle fill o-5"></div>
    </div>
</div>

<!-- [Content] Submit Button -->

<div *ngIf="is.submit" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div *ngIf="placeholder" class="button-placeholder" [innerHTML]="placeholder | safeHtml"></div>
    <button type="submit" [disabled]="item.disabled" (click)="actions[item.value]()">{{item.label}}</button>
    <div *ngIf="item.hint" class="button-hint" [innerHTML]="item.hint | safeHtml"></div>
</div>

<!-- [Content] Table -->

<div *ngIf="is.table" [class]="className" [ngClass]="{ hide: !item.visible, valid: item.valid, required: item.required }">
    <div class="table-container">
        <table>
            <thead>
                <tr class="sr-only">
                    <th scope="col">Options</th>
                </tr>
                <tr>
                    <th
                        *ngFor="let cell of getTableHeaderCells(item.label)"
                        [class]="cell.className || null"
                        [attr.colspan]="cell.colSpan"
                        [attr.rowspan]="cell.rowSpan"
                        [attr.style]="cell.style"
                        [innerHTML]="cell.html | safeHtml"
                    ></th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="let row of item.items"
                    [class]="row.className"
                    tabindex="0"
                    (click)="selectTableRow(item, row, $event)"
                    (keydown.enter)="selectTableRow(item, row, $event)"
                    (keydown.space)="selectTableRow(item, row, $event); $event.preventDefault()"
                >
                    <ng-template ngFor let-cell [ngForOf]="getTableRowCells(row.label)">
                        <td
                            *ngIf="!cell.radio"
                            [class]="cell.className || null"
                            [attr.colspan]="cell.colSpan"
                            [attr.rowspan]="cell.rowSpan"
                            [attr.style]="cell.style"
                            [innerHTML]="cell.html | safeHtml"
                        ></td>
                        <td
                            *ngIf="cell.radio"
                            [class]="cell.className || null"
                            [attr.colspan]="cell.colSpan"
                            [attr.rowspan]="cell.rowSpan"
                            [attr.style]="cell.style"
                        >
                            <input
                                type="radio"
                                [id]="cell.radio.id"
                                [name]="cell.radio.name"
                                [checked]="cell.radio.checked"
                                [disabled]="cell.radio.disabled"
                                (change)="updateFromInput(item, 'value', row.itemId)"
                            >
                            <span *ngIf="cell.html" [innerHTML]="cell.html | safeHtml"></span>
                        </td>
                    </ng-template>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="scroll-container">
        <div class="scroll-bar"></div>
    </div>
</div>

<!-- Child Items -->

<ng-template [ngIf]="item.items && is.checkbox || is.text || is.number">
    <infinity-item *ngFor="let child of item.items" [item]="child" [parent]="item" [actions]="actions"></infinity-item>
</ng-template>
